export default __webpack_public_path__ + "static/media/Favourite-league.1d655b96.png";